import { render, staticRenderFns } from "./FInput.vue?vue&type=template&id=85a1b494&"
import script from "./FInput.vue?vue&type=script&lang=js&"
export * from "./FInput.vue?vue&type=script&lang=js&"
import style0 from "./FInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports